export default {
    methods: {
        async getNotificationList(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/notification/list', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async getNotificationDetails(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/notification/view', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async ChangeReadStatus(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/notification/read', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        },
        async markAllAsReadApi(params) {
            return new Promise(async (resolve, reject) => {
                let response = await this.$http.post('/notification/read_all_notifications', params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data)
                }
            })
        }
    }
}